/**
*
*   Giveraway Form
*       - A Giveaway Signup Form
*
**/
'use client';

import Button from '@/components/button';
import Recaptcha from '@/libraries/recaptcha';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useTranslations } from 'next-intl';
import { useReCaptcha } from 'next-recaptcha-v3';
import { useState } from 'react';


//Build the Element
export default function GiveawayInviteForm({ subscriber = 'Someone' }){

	//The Form Settings
	const { control, register, setError, setValue, formState: { errors, isSubmitting, isSubmitSuccessful }, handleSubmit } = useForm();

	//Current Form State
	const [ status , setStatus ] = useState(false);

	//Is the form loading
	const [ loading , setLoading ] = useState(false);

	//Page Translations
	const t = useTranslations();

	//Recaptcha
	const { executeRecaptcha } = useReCaptcha();

	//Form Settings
	const Form = {

		//Settings
		email: {
			validate: email => {
				return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email) || t('Forms.Errors.email.invalid'); //eslint-disable-line no-useless-escape
			}
		},

		//Error
		error: ({ message }) => <p className="error">{ message }</p> ,

		//A Thrown Error Message
		thrown: ( message ) => setError('root.serverError',{
			type: 500,
			message: `${ t('Forms.Errors.unknown')  } ${  message }`
		}),

		//On Submit
		submit: async data => {

			setLoading(true);

			const token = await executeRecaptcha('giveaway/invite');

			fetch( '/api/email' , {
				method: 'POST',
				body:   JSON.stringify({
					token:      token,
					to:         data.email,
					template:   'giveaway',
					subject:    'Win a Fern & Petal Gift Card',
					body:       {
						subscriber: subscriber
					}
				})
			})
			//Format to JSON
			.then( res => res.json() )

			//Success
			.then( response => {

				//Set Success or Failure
				setStatus( response.result );

				//Stop Loading
				setLoading(false);

				//An Error Occured
				if(!response.result )
					return Form.thrown( JSON.stringify( response.error ) );

				//Clear the EmaiL Field
				setValue('email','');

			})

			//Catch Error
			.catch( err => {
				setLoading(false);
				Form.thrown( err.toString() );
			});
		}
	};


	return (
		<section id="share" className="container">
			<header>
				<h2>
					Get even more chances to win
				</h2>
				<p>
					Recommending this contest to a friend and you&apos;ll get an additional <strong>3</strong> entries for each email you send!
				</p>
			</header>
			<form onSubmit={ handleSubmit(Form.submit) }>

				{/* Submission Response Error */}
				{ errors.root?.serverError?.type > 200 && (
					<div className="failed">{
						errors.root.serverError.message
					}</div>
				) }

				{/* Submission Response Success */}
				{ status && (
					<p className="success">
						Recommendation sent! You have now received <strong>3</strong> additional entries. Do you want to send another?
					</p>
				)}

				<div className="row">
					<div>
						<label htmlFor="email">{ t('Forms.Labels.email') }</label>
						<input name="email" placeholder={ `${ t('Forms.Labels.email')  }*` } {...register('email', { required:  t('Forms.Errors.required',{ type: t('Forms.Labels.email') }), validate: Form.email.validate })} />
						<ErrorMessage errors={errors} name="email" render={ Form.error } />
					</div>
				</div>

				{/* Submit */}
				<div className="row">
					<div>
						<Button disabled={ isSubmitting || loading } button type="submit">{ t('Forms.Labels.submit') }</Button>
					</div>
				</div>

				{/* Footer */}
				<footer>

					{/* Recaptcha Message */}
					<p>{ Recaptcha.message }</p>

				</footer>
			</form>
		</section>
	);

}